import { useEffect, useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const [form, setForm] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [stats, setStats] = useState({})
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    window.location = "/";
  };
  useEffect(() => {
    // később lehet GET profile
    API.get("/auth/me").then((res) => {
      setForm(res.data);
    }
    );
    API.get("/orders/stats").then((res) => {
      setStats(res.data);
    }
    );
  }, []);

  const save = () => {
    API.put("/auth/profile", form).then((res) => {
      navigate("/")
    });
  };

  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{6,}$/;

  const changePassword = () => {
    if (confirmPassword === password) {
      if (!passwordRegex.test(password)) {
        alert("A jelszónak legalább 6 karakter hosszúnak kell lennie, és tartalmaznia kell betűt, számot és speciális karaktert!");
        return;
      }
      //console.log("Jelszo megvaltoztatva: " + password)
      API.put("/auth/password", { password }).then((res) => {
        //console.log(res.status)
        //console.log(res.data)
        logout();
      });
    }
    else {
      alert("Nem egyezik meg a két megadott jelszó!")
    }
  };

  const formatPrice = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (Number.isNaN(n)) return value;
    return new Intl.NumberFormat('hu-HU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true
    }).format(n) + ' Ft';
  }

  return (
    <div className="p-6">
      <div className="bg-white shadow p-4 rounded mb-6">
        <h2 className="text-xl mb-4">Statisztikák</h2>
          <ul className="text-sm">
            <li>Összesen {stats.total_num} darab (ebből {stats.total_shared_num} veled megosztott) rendelésed van és ezek összege: {formatPrice(stats.total_all) || "N/A"}.</li>
            <li>Kifizetett rendeléseid összege: {formatPrice(stats.total_paid) || "N/A"}.</li>
            <li>Ki nem fizetett rendeléseid összege: {formatPrice(stats.total_not_paid) || "N/A"}.</li>
            <li>Megérkezett összesen {stats.total_arrived_num || "N/A"} rendelésed.</li>
            <li>Még vársz {stats.total_not_arrived_num || "N/A"} rendelésre.</li>
          </ul>
      </div>
      <div className="bg-white shadow p-4 rounded mb-6">
        <h2 className="text-xl mb-4">Profilod adatai</h2>

        <label htmlFor="display_name" className="text-l mb-4">Megjelenített név: </label>
        <input
          value={form.display_name || ""}
          id='display_name'
          placeholder="Megjelenített név"
          className="border p-2 mb-2 block"
          onChange={(e) =>
            setForm({
              ...form,
              display_name: e.target.value,
            })
          }
        />

        <label htmlFor="email" className="text-l mb-4">Email: </label>
        <input
          value={form.email || ""}
          id='email'
          placeholder="Email címed"
          className="border p-2 mb-2 block"
          onChange={(e) =>
            setForm({ ...form, email: e.target.value })
          }
        />

        <button
          className="bg-blue-500 text-white px-3 mb-4"
          onClick={save}
        >
          Mentés
        </button>
        <hr className="mt-4 mb-4"></hr>
        <h2 className="text-xl mb-4">Jelszó változtatás</h2>
        <span className="text-xs text-gray-400 mb-2">
          {'(Minimum 6 karaktert adj meg. Tartalmaznia kell betűt, számot és speciális karaktert (!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~).)'}
        </span>
        <input
          id='password'
          type="password"
          placeholder="Jelszavad"
          className="border p-2 mb-2 block"
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          id="password_again"
          placeholder="Jelszavad mégegyszer"
          type="password"
          className="border p-2 mb-2 block"
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <button
          className="bg-green-500 text-white px-3"
          onClick={changePassword}
        >
          Jelszó megváltoztatása
        </button>
      </div>
    </div>
  );
}